import request from '@/utils/request'

export function updateSignInCfg(data) {
  return request({
    url: 'api/v1/sign-in/updateSignIn',
    method: 'post',
    data: data
  })
}

export function updateSuperSignInCfg(data) {
  return request({
    url: 'api/v1/sign-in/updateSuperSignIn',
    method: 'post',
    data: data
  })
}

export function getSignInCfgList(data) {
  return request({
    url: 'api/v1/sign-in/getSignIn',
    method: 'post',
    data: data
  })
}

export function getSuperSignInCfgList(data) {
  return request({
    url: 'api/v1/sign-in/getSuperSignIn',
    method: 'post',
    data: data
  })
}

export function exportSuperSign(data) {
  return request({
    url: 'api/v1/sign-in/export',
    method: 'post',
    data: data
  })
}

export function importSuperSign(data) {
  return request({
    url: 'api/v1/sign-in/import',
    method: 'post',
    data: data
  })
}

export function delSignInCfg(data) {
  return request({
    url: 'api/v1/sign-in/delSignIn',
    method: 'delete',
    data: data
  })
}
